import { defineMessages } from 'react-intl';
//
// ─── INTERFACES ─────────────────────────────────────────────────────────────────
//
export enum ApiErrorMessage {
	UnauthorisedTitle = 'UnauthorisedTitle',
	UnauthorisedMsg = 'UnauthorisedMsg',
	MissingPermissionsTitle = 'MissingPermissionsTitle',
	MissingPermissionsMsg = 'MissingPermissionsMsg',
	AddConnectionFailedTitle = 'AddConnectionFailedTitle',
	AddConnectionFailedMsg = 'AddConnectionFailedMsg',
	UpdateConnectionFailedTitle = 'UpdateConnectionFailedTitle',
	UpdateConnectionFailedMsg = 'UpdateConnectionFailedMsg',
	SubmitFormFailedTitle = 'SubmitFormFailedTitle',
	SubmitFormFailedMsg = 'SubmitFormFailedMsg',
	SaveFormFailedTitle = 'SaveFormFailedTitle',
	SaveFormFailedMsg = 'SaveFormFailedMsg',
	SaveFormInvalidAnswersMsg = 'SaveFormInvalidAnswersMsg',
	SaveFormFailedOnConflictMsg = 'SaveFormFailedOnConflictMsg',
	SaveTemplateFormFailedTitle = 'SaveTemplateFormFailedTitle',
	SaveTemplateFormFailedMsg = 'SaveTemplateFormFailedMsg',
	LoadTemplateFormFailedTitle = 'LoadTemplateFormFailedTitle',
	LoadTemplateFormFailedMsg = 'LoadTemplateFormFailedMsg',
	LoadJiraFieldsFailedTitle = 'LoadJiraFieldsFailedTitle',
	LoadJiraFieldsFailedMsg = 'LoadJiraFieldsFailedMsg',
	LoadDataConnectionsFailedTitle = 'LoadDataConnectionsFailedTitle',
	LoadDataConnectionsFailedMsg = 'LoadDataConnectionsFailedMsg',
	LoadSettingsRefDataFailedTitle = 'LoadSettingsRefDataFailedTitle',
	LoadSettingsRefDataFailedMsg = 'LoadSettingsRefDataFailedMsg',
}

export const IntlApiErrorMessages: {
	UnauthorisedTitle: {
		id: string;
		defaultMessage: string;
	};
	UnauthorisedMsg: {
		id: string;
		defaultMessage: string;
	};
	MissingPermissionsTitle: {
		id: string;
		defaultMessage: string;
	};
	MissingPermissionsMsg: {
		id: string;
		defaultMessage: string;
	};
	AddConnectionFailedTitle: {
		id: string;
		defaultMessage: string;
	};
	AddConnectionFailedMsg: {
		id: string;
		defaultMessage: string;
	};
	UpdateConnectionFailedTitle: {
		id: string;
		defaultMessage: string;
	};
	UpdateConnectionFailedMsg: {
		id: string;
		defaultMessage: string;
	};
	SubmitFormFailedTitle: {
		id: string;
		defaultMessage: string;
	};
	SubmitFormFailedMsg: {
		id: string;
		defaultMessage: string;
	};
	SaveFormFailedTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	SaveFormFailedMsg: {
		id: string;
		defaultMessage: string;
	};
	SaveFormInvalidAnswersMsg: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	SaveFormFailedOnConflictMsg: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	SaveTemplateFormFailedTitle: {
		id: string;
		defaultMessage: string;
	};
	SaveTemplateFormFailedMsg: {
		id: string;
		defaultMessage: string;
	};
	LoadTemplateFormFailedTitle: {
		id: string;
		defaultMessage: string;
	};
	LoadTemplateFormFailedMsg: {
		id: string;
		defaultMessage: string;
	};
	LoadJiraFieldsFailedTitle: {
		id: string;
		defaultMessage: string;
	};
	LoadJiraFieldsFailedMsg: {
		id: string;
		defaultMessage: string;
	};
	LoadDataConnectionsFailedTitle: {
		id: string;
		defaultMessage: string;
	};
	LoadDataConnectionsFailedMsg: {
		id: string;
		defaultMessage: string;
	};
	LoadSettingsRefDataFailedTitle: {
		id: string;
		defaultMessage: string;
	};
	LoadSettingsRefDataFailedMsg: {
		id: string;
		defaultMessage: string;
	};
} = defineMessages({
	[ApiErrorMessage.UnauthorisedTitle]: {
		id: 'ui-notices.apiError.title.UnauthorisedTitle',
		defaultMessage: 'Error: User Unauthorised',
		description:
			'Title of the error notice shown when the user is unauthorized to perform an action',
	},
	[ApiErrorMessage.UnauthorisedMsg]: {
		id: 'ui-notices.apiError.msg.UnauthorisedMsg',
		defaultMessage: 'Try refreshing your page or logging into Jira again.',
		description: 'Error message body instructing the user to refresh or re-login when unauthorized',
	},
	[ApiErrorMessage.MissingPermissionsTitle]: {
		id: 'ui-notices.apiError.title.MissingPermissionsTitle',
		defaultMessage: 'Error: User is not allowed this action',
		description: 'Title of the error notice shown when the user lacks permissions for an action',
	},
	[ApiErrorMessage.MissingPermissionsMsg]: {
		id: 'ui-notices.apiError.msg.MissingPermissionsMsg',
		defaultMessage:
			'You do not have the necessary permissions to perform this action. Please contact your Jira Administrator.',
		description:
			'Error message body shown when the user lacks required permissions to perform an action',
	},
	[ApiErrorMessage.AddConnectionFailedTitle]: {
		id: 'ui-notices.apiError.title.AddConnectionFailedTitle',
		defaultMessage: 'Error: Adding data connection failed',
		description: 'Title of the error notice shown when adding a data connection fails',
	},
	[ApiErrorMessage.AddConnectionFailedMsg]: {
		id: 'ui-notices.apiError.msg.AddConnectionFailedMsg',
		defaultMessage: 'A server error occurred while trying to add the data connection.',
		description:
			'Error message body shown when a server error prevents a data connection from being added',
	},
	[ApiErrorMessage.UpdateConnectionFailedTitle]: {
		id: 'ui-notices.apiError.title.UpdateConnectionFailedTitle',
		defaultMessage: 'Error: Updating data connection failed',
		description: 'Title of the error notice shown when updating a data connection fails',
	},
	[ApiErrorMessage.UpdateConnectionFailedMsg]: {
		id: 'ui-notices.apiError.msg.UpdateConnectionFailedMsg',
		defaultMessage: 'A server error occurred while trying to update the data connection.',
		description:
			'Error message body shown when a server error prevents a data connection from being updated',
	},
	[ApiErrorMessage.SubmitFormFailedTitle]: {
		id: 'ui-notices.apiError.title.SubmitFormFailedTitle',
		defaultMessage: 'Error: Submitting form failed',
		description: 'Title of the error notice shown when form submission fails due to a server error',
	},
	[ApiErrorMessage.SubmitFormFailedMsg]: {
		id: 'ui-notices.apiError.msg.SubmitFormFailedMsg',
		defaultMessage: 'A server error occurred while trying to submit the form.',
		description:
			'Error message body shown when a server error prevents the form from being submitted',
	},
	[ApiErrorMessage.SaveFormFailedTitle]: {
		id: 'ui-notices.apiError.title.SaveFormFailedTitle',
		defaultMessage: 'We couldn’t save your changes',
		description: 'The title on the error flag informing customers that their form failed to save.',
	},
	[ApiErrorMessage.SaveFormFailedMsg]: {
		id: 'ui-notices.apiError.msg.SaveFormFailedMsg',
		defaultMessage: 'A server error occurred while trying to save the form.',
		description: 'Error message body shown when a server error prevents the form from being saved',
	},
	[ApiErrorMessage.SaveFormInvalidAnswersMsg]: {
		id: 'ui-notices.apiError.msg.SaveFormInvalidAnswersMsg',
		defaultMessage: 'Resolve any invalid answers and check all required fields are complete.',
		description:
			'The error message on the error flag informing customers that their form failed to save due to invalid answers.',
	},
	[ApiErrorMessage.SaveFormFailedOnConflictMsg]: {
		id: 'ui-notices.apiError.msg.SaveFormFailedOnConflictMsg',
		defaultMessage:
			'The settings for this form have been changed. If you believe this was an error, leave a comment on the request.',
		description:
			"The error message on error flag informing customers about what happened and what to do when saving form answers request was rejected because the form state doesn't allow the customer to do so.",
	},
	[ApiErrorMessage.SaveTemplateFormFailedTitle]: {
		id: 'ui-notices.apiError.title.SaveTemplateFormFailedTitle',
		defaultMessage: 'Error: Saving template form failed',
		description: 'Title of the error notice shown when saving a template form fails',
	},
	[ApiErrorMessage.SaveTemplateFormFailedMsg]: {
		id: 'ui-notices.apiError.msg.SaveTemplateFormFailedMsg',
		defaultMessage: 'A server error occurred while trying to save the template form.',
		description:
			'Error message body shown when a server error prevents the template form from being saved',
	},
	[ApiErrorMessage.LoadTemplateFormFailedTitle]: {
		id: 'ui-notices.apiError.title.LoadTemplateFormFailedTitle',
		defaultMessage: 'We couldn’t load your form',
		description: 'Title of the error notice shown when loading a template form fails',
	},
	[ApiErrorMessage.LoadTemplateFormFailedMsg]: {
		id: 'ui-notices.apiError.msg.LoadTemplateFormFailedMsg',
		defaultMessage: 'Refresh the page to try again',
		description:
			'Error message body shown when loading the template form fails, instructing the user to refresh',
	},
	[ApiErrorMessage.LoadJiraFieldsFailedTitle]: {
		id: 'ui-notices.apiError.title.LoadJiraFieldsFailedTitle',
		defaultMessage: 'Error: Loading Jira fields failed',
		description:
			'Title of the error notice shown when Jira fields fail to load on the template form',
	},
	[ApiErrorMessage.LoadJiraFieldsFailedMsg]: {
		id: 'ui-notices.apiError.msg.LoadJiraFieldsFailedMsg',
		defaultMessage:
			'A server error occurred while trying to load Jira fields on the template form.',
		description:
			'Error message body shown when a server error prevents Jira fields from loading on the template form',
	},
	[ApiErrorMessage.LoadDataConnectionsFailedTitle]: {
		id: 'ui-notices.apiError.title.LoadDataConnectionsFailedTitle',
		defaultMessage: 'Error: Loading data connections failed.',
		description:
			'Title of the error notice shown when data connections fail to load on the template form',
	},
	[ApiErrorMessage.LoadDataConnectionsFailedMsg]: {
		id: 'ui-notices.apiError.msg.LoadDataConnectionsFailedMsg',
		defaultMessage:
			'A server error occurred while trying to load data connections on the template form.',
		description:
			'Error message body shown when a server error prevents data connections from loading on the template form',
	},
	[ApiErrorMessage.LoadSettingsRefDataFailedTitle]: {
		id: 'ui-notices.apiError.title.LoadSettingsRefDataFailedTitle',
		defaultMessage: 'Error: Loading form settings reference data failed.',
		description: 'Title of the error notice shown when form settings reference data fails to load',
	},
	[ApiErrorMessage.LoadSettingsRefDataFailedMsg]: {
		id: 'ui-notices.apiError.msg.LoadSettingsRefDataFailedMsg',
		defaultMessage:
			"A server error occurred while trying to load the reference for the template form's settings.",
		description:
			'Error message body shown when a server error prevents form settings reference data from loading',
	},
});
